export const parseImageQuery = (data, dataSetKey = 'gallery') => {
	const galleryImages = data[dataSetKey].edges
		.map((dataObj) => dataObj)
		.map(({ node }) => node)
		.map((image) => ({
			imageName: image.childImageSharp.fluid.originalName
				.split('.')
				.slice(0, -1)
				.join('.'),
			original: image.childImageSharp.fluid.src,
			thumbnail: image.childImageSharp.fluid.src,
			fluid: image.childImageSharp.fluid,
		}));

	return [galleryImages, data.hero ? data.hero.childImageSharp.fluid : null];
};

export const parseImageQueryGrid = (data, dataSetKey) => {
	const gridImages = data[dataSetKey].edges
		.map((dataObj) => dataObj)
		.map(({ node }) => node)
		.map((image) => ({
			imageName: image.childImageSharp.fluid.originalName
				.split('.')
				.slice(0, -1)
				.join('.'),
			original: image.childImageSharp.fluid.src,
			thumbnail: image.childImageSharp.fluid.src,
			fluid: image.childImageSharp.fluid,
		}));

	return gridImages;
};
